/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { INurse } from 'app/shared/model/nurse.model';

export interface IPreOpSignIn {
  id?: string;
  patientConfirmation?: boolean;
  identity?: boolean;
  siteAndSide?: boolean;
  procedure?: boolean;
  consent?: boolean;
  siteMarked?: boolean;
  anaesthesiaCheck?: boolean;
  knownAllergies?: boolean;
  airwayRisk?: boolean;
  bloodLoss?: boolean;
  bloodReserved?: boolean;
  documentsReady?: boolean;
  equipmentReady?: boolean;
  implantReady?: boolean;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  surgery?: IPatientProcedure;
  anaesthesiologist?: IDoctor;
  nurse?: INurse;
}

export const defaultValue: Readonly<IPreOpSignIn> = {
  patientConfirmation: false,
  identity: false,
  siteAndSide: false,
  procedure: false,
  consent: false,
  siteMarked: false,
  anaesthesiaCheck: false,
  knownAllergies: false,
  airwayRisk: false,
  bloodLoss: false,
  bloodReserved: false,
  documentsReady: false,
  equipmentReady: false,
  implantReady: false,
  active: false,
};
